export const options = (currencySymbol) => {
    return {
        colors: ["#FFCC00", "#00884C"],
        stroke: { curve: 'smooth' },
        yaxis: {
            labels: {
                formatter: function (value) {
                    return currencySymbol + ' ' + value;
                }
            },
        },
        chart: {
            id: "basic-bar",
            background: '#F4F5F6',
            toolbar: {
                show: false,
                tools: {
                    download: false
                }
            }
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
    }
}

export const donationsData = {
    given: {
        name: "Donations Given",
        color: "#FFCC00",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    received: {
        name: "Donations Received",
        color: "#00884C",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }
}